module.exports = __webpack_public_path__ + "static/media/pexels-photo-1525612.4aa47e89.jpg";